class FreeShippingBar extends HTMLElement {
  constructor() {
    super();
    this.threshold = parseInt(this.dataset.threshold, 10) || 0; // cents
    this.fill = this.querySelector('[data-free-shipping-bar-fill]');
    this.message = this.querySelector('[data-free-shipping-bar-message]');
  }

  connectedCallback() {
    const initialTotal = parseInt(this.dataset.initialTotal, 10) || 0;
    this.render(initialTotal);
    this.bindCartUpdates();
  }

  disconnectedCallback() {
    if (typeof this._unsubscribe === 'function') this._unsubscribe();
  }

  bindCartUpdates() {
    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      this._unsubscribe = window.MinimogEvents.subscribe(
        window.MinimogTheme.pubSubEvents.cartUpdate,
        this.handleCartUpdate.bind(this)
      );
    } else {
      // Core theme scripts not parsed yet — retry once DOM is ready.
      document.addEventListener('DOMContentLoaded', () => this.bindCartUpdates(), { once: true });
    }
  }

  handleCartUpdate() {
    // Always re-fetch cart.json rather than trusting the event payload,
    // since different call sites (add / change / update) emit different shapes.
    fetchJSON(window.Shopify.routes.root + 'cart.json')
      .then((cart) => this.render(cart.total_price))
      .catch((error) => console.error('Free shipping bar: failed to refresh cart', error));
  }

  render(totalPriceCents) {
    const remaining = this.threshold - totalPriceCents;
    const progress = this.threshold > 0
      ? Math.min(100, Math.max(0, (totalPriceCents / this.threshold) * 100))
      : 100;

    if (this.fill) {
      requestAnimationFrame(() => {
        this.fill.style.width = `${progress}%`;
      });
    }

    let state = 'progress';
    let text = '';

    if (totalPriceCents <= 0) {
      state = 'empty';
      text = this.dataset.emptyText;
    } else if (remaining <= 0) {
      state = 'complete';
      text = this.dataset.successText;
    } else {
      state = 'progress';
      const moneyFormat = (window.MinimogSettings && window.MinimogSettings.money_format) || '${{amount}}';
      const amount = formatMoney(remaining, moneyFormat);
      text = (this.dataset.progressText || '').replace('__AMOUNT__', amount);
    }

    if (this.message) this.message.textContent = text;

    this.classList.remove('free-shipping-bar--empty', 'free-shipping-bar--progress', 'free-shipping-bar--complete');
    this.classList.add(`free-shipping-bar--${state}`);
  }
}

if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', FreeShippingBar);
}